
import dayjs from 'dayjs'

const YMDHMS = 'YYYY-MM-DD HH:mm:ss'
const MONTH = 'month'
function fmtDate(date=Date.now()) {
  return dayjs(date).format(YMDHMS)
}

// 本月
export function thisMonth() {
  const begin = dayjs().startOf(MONTH)
  const end = dayjs().endOf(MONTH)
  return [ fmtDate(begin), fmtDate(end) ]
}
// 上月
export function lastMonth() {
  const begin = dayjs().subtract(1, MONTH).startOf(MONTH)
  const end = dayjs().subtract(1, MONTH).endOf(MONTH)
  return [ fmtDate(begin), fmtDate(end) ]
}
// 6个月前
export function lastSixMonth() {
  const begin = dayjs().subtract(5, MONTH).startOf(MONTH)
  const end = dayjs().endOf(MONTH)
  return [ fmtDate(begin), fmtDate(end) ]
}


export function getModel() {
  return [
    {
      label: '本月',
      date: thisMonth(), // [0]:开始日期，[1]:结束日期
      list: [],
      summary: {},    // 只在零元购有用
      summary_by_day: [], // 只在零元购有用
    },
    {
      label: '上月',
      date: lastMonth(), // [0]:开始日期，[1]:结束日期
      list: [],
      summary: {},    // 只在零元购有用
      summary_by_day: [], // 只在零元购有用
    },
    {
      label: '自定义',
      date: lastSixMonth(), // [0]:开始日期，[1]:结束日期
      list: [],
      summary: {},    // 只在零元购有用
      summary_by_day: [], // 只在零元购有用
    },
  ]
}